// services
import WsBasicService from '../Basic';
// consts
import { URL_AWS } from './const';
import { LiveFeedMessage } from './typings';

class LiveFeedStore extends WsBasicService<LiveFeedMessage> {}

export default new LiveFeedStore({ key: 'liveV2', URL: URL_AWS });
